import './active_material/fonts'
import './active_material/actions-toggle'

document.querySelector('html').className += ' am-js'